<template>
  <div :class="classes" >
    <pt-page-title title="生命体验馆预约参观" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      <template  slot="on-right">
        <span v-if="unreadNotificationsNoReadCount === 0" @click="goNotification" class="iconfont notification-icon">&#xe733;</span>
        <el-badge v-if="unreadNotificationsNoReadCount !== 0" :value="unreadNotificationsNoReadCount" class="item" type="primary">
            <span @click="goNotification" class="iconfont notification-icon">&#xe733;</span>
        </el-badge>
      </template>
      <template slot="before-left">
        <el-button type="primary" @click="manageReservation">管理场次</el-button>
      </template>
    </pt-page-title>
    <pt-page-menu-filter :tabs="tabs" v-model="selectTab" @fromRouter="fromRouter" :showCountOfRightTop="true" isRouteQuery></pt-page-menu-filter>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <template>
        <el-button type="primary" @click="exportOldToNewAudit()" :loading="exportLoading">导出</el-button>
        <!-- <el-button type="primary" @click="exportOldToNewAudit(true)" v-if="hasAllExport" :loading="exportLoading">导出全部记录</el-button> -->
        <el-button type="primary" @click="exportHistoryOldToNewAudit">导出历史</el-button>
      </template>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-life-experience-pavilion-reservation-table :tableLabels="tableLabels" ref="table" :params="paramsData"
    :class="$style['pt-hospital-table']" :isFromRouter="isFromRouter">
    </pt-life-experience-pavilion-reservation-table>
  </div>
</template>

<script>
import {
  lifeExperiencePavilionReservationTableLabels
  , filterLabels, statusTabs } from './life-experience-pavilion-reservation'
import ptLifeExperiencePavilionReservationTable from './pt-life-experience-pavilion-reservation-table/withData'
import { emptyObject } from 'utils/lifebankUtils'
const prefixCls = 'pt-life-experience-pavilion-reservation'

export default {
  name: 'pt-life-experience-pavilion-reservation',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLifeExperiencePavilionReservationTable
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    },
    waitAuditCount: Number
  },
  data () {
    return {
      params: {},
      filterLabels: filterLabels,
      tableLabels: lifeExperiencePavilionReservationTableLabels,
      searchKey: '',
      unreadNotificationsNoReadCount: 0,
      intervalId: null,
      tabs: statusTabs,
      isFromRouter: false,
      selectTab: 'ALL',
      paramsData: {}
    }
  },
  watch: {
    selectTab: {
      handler: function (val, old) {
        this.searchKey = null
        this.paramsData = { status: val }
      },
      immediate: true
    },
    waitAuditCount (val) {
      this.tabs = statusTabs.map(item => {
        if (item.value === 'WAITING_AUDIT') {
          return {
            ...item,
            count: val
          }
        } else {
          return {
            ...item
          }
        }
      })
    }
  },
  mounted () {
    this.getTime()
    this.getReservationNotificationsNoReadCount()
    this.startPolling()
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    fromRouter (val) {
      this.isFromRouter = val
    },
    goNotification () {
      this.$router.push('/reservation-notifications')
    },
    startPolling () {
      this.intervalId = setInterval(() => {
        this.getReservationNotificationsNoReadCount()
      }, 30000)
    },
    stopPolling () {
      clearInterval(this.intervalId)
    },
    search (val) {
      this.isFromRouter = false
      this.searchKey = val
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    getReservationNotificationsNoReadCount () {
      this.$store
        .dispatch('getReservationNotificationsNoReadCount')
        .then(res => {
          this.unreadNotificationsNoReadCount = res
        })
        .catch(err => {
          this.$message.error(err || '获取失败')
        })
    },
    getTime () {
      this.$store
        .dispatch('getLifeExperienceHallsReservationTime')
        .then(res => {
          this.filterLabels[1].options = []
          res.map(item => {
            this.filterLabels[1].options.push({
              value: item.id,
              label: item.name
            })
          })
        })
        .catch(err => {
          this.$message.error(err || '取消失败')
        })
    },
    manageReservation () {
      this.$router.push('/manage-reservation')
    },
    filter () {
      this.searchKey = null
      this.paramsData = { ...this.params }
      for (var key2 in this.paramsData) {
        if (!this.paramsData[key2]) {
          this.$delete(this.paramsData, key2)
        }
      }
    },
    exportOldToNewAudit () {
      if (this.$refs.table.tableData && this.$refs.table.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.paramsData }
          for (var key2 in params) {
            if (!params[key2]) {
              this.$delete(params, key2)
            }
          }
          this.$emit('reservationExport', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    // 导出历史
    exportHistoryOldToNewAudit () {
      this.$router.push('/export-history/reservation-export?name=reservation_export')
    },
    async cleanParams () {
      this.params = {}
      this.paramsData = {}
      await this.$nextTick()
    },
    getTableData () {
      this.$refs.table.resetPage()
      this.$refs.table.getTableData()
    }
  }
}

</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-hospital-table {
  :global .iconfont {
    margin-right: 10px;
  }
}
.download-qrcode{
  color:#edbe81
}
</style>
<style scoped lang="less">
  /deep/ .el-badge__content.is-fixed {
    top:12px
  }
  .notification-icon {
    cursor: pointer;
    font-size: 22px !important;
  }
</style>
